// Types
import { ReviewTemplateTypeType } from 'Shared/types/ReviewTemplates.type';

// Constants
import ReviewTemplatesConstants from 'Shared/constants/ReviewTemplates.constants';

// Helpers
import { showNotificationError } from 'Shared/helpers';

// Normalizer
import ReviewTemplateSchema from 'Shared/utils/normalizeJSON/schemas/ReviewTemplate.schema';
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

// API
import * as api from 'Shared/api/ReviewTemplates.api';

export const fetchReviewTemplatesSuccess = payload => ({
  type: ReviewTemplatesConstants.Actions.FETCH_REVIEW_TEMPLATES_SUCCESS,
  payload,
});

export const fetchReviewTemplateSuccess = payload => ({
  type: ReviewTemplatesConstants.Actions.FETCH_REVIEW_TEMPLATE_SUCCESS,
  payload,
});

export const createReviewTemplateSuccess = payload => ({
  type: ReviewTemplatesConstants.Actions.CREATE_REVIEW_TEMPLATE_SUCCESS,
  payload,
});

export const updateReviewTemplateSuccess = payload => ({
  type: ReviewTemplatesConstants.Actions.UPDATE_REVIEW_TEMPLATE_SUCCESS,
  payload,
});

export const duplicateReviewTemplateSuccess = payload => ({
  type: ReviewTemplatesConstants.Actions.DUPLICATE_REVIEW_TEMPLATE_SUCCESS,
  payload,
});

export const deleteReviewTemplateSuccess = payload => ({
  type: ReviewTemplatesConstants.Actions.DELETE_REVIEW_TEMPLATE_SUCCESS,
  payload,
});

export const fetchReviewTemplates = ({ templateType }: { templateType: ReviewTemplateTypeType }) => dispatch => {
  return api
    .fetchReviewTemplates({ templateType })
    .then(response => {
      dispatch(fetchReviewTemplatesSuccess(normalizer(ReviewTemplateSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const fetchReviewTemplate = ({
  slug,
  dataFormat = 'jsonapi',
}: {
  slug: string;
  dataFormat?: 'jsonapi' | null;
}) => dispatch => {
  return api
    .fetchReviewTemplate(slug, { data_format: dataFormat })
    .then(response => {
      dispatch(fetchReviewTemplateSuccess(normalizer(ReviewTemplateSchema, response.data)));
      return response.data;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const createReviewTemplate = ({
  name,
  description,
  templateType,
  version,
}: api.createReviewTempateDataType) => dispatch => {
  return api.createReviewTemplate({ name, description, templateType, version }).then(response => {
    dispatch(createReviewTemplateSuccess(normalizer(ReviewTemplateSchema, response.data)));
    return response.data;
  });
};

export const duplicateReviewTemplate = ({
  name,
  duplicateFromSlug,
}: api.duplicateReviewTempateDataType) => dispatch => {
  return api.duplicateReviewTemplate({ name, duplicateFromSlug }).then(response => {
    dispatch(duplicateReviewTemplateSuccess(normalizer(ReviewTemplateSchema, response.data)));
    return response.data;
  });
};

export const updateReviewTemplate = ({ slug, reviewTemplate }: api.updateReviewTemplateDataType) => dispatch => {
  return api.updateReviewTemplate({ slug, reviewTemplate }).then(response => {
    dispatch(updateReviewTemplateSuccess(normalizer(ReviewTemplateSchema, response.data)));
    return response.data;
  });
};

export const deleteReviewTemplate = ({ slug }: api.deleteReviewTemplateDataType) => dispatch => {
  return api.deleteReviewTemplate({ slug }).then(response => {
    dispatch(deleteReviewTemplateSuccess({ slug }));
    return response.data;
  });
};
